import { render, staticRenderFns } from "./distributor-setting.vue?vue&type=template&id=30dc11ce"
import script from "./distributor-setting.vue?vue&type=script&lang=js"
export * from "./distributor-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30dc11ce')) {
      api.createRecord('30dc11ce', component.options)
    } else {
      api.reload('30dc11ce', component.options)
    }
    module.hot.accept("./distributor-setting.vue?vue&type=template&id=30dc11ce", function () {
      api.rerender('30dc11ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Distribution/distributor-setting.vue"
export default component.exports